import { useDelete } from '@refinedev/core';
import { Client } from '../../admin/users/types';

export function useDeleteClient() {
  const { mutateAsync, error, isLoading, reset } = useDelete<Client>();

  const deleteClient = async (id: string) => {
    return mutateAsync({
      resource: 'clients',
      id,
    });
  };

  return {
    deleteClient,
    error,
    isLoading,
    reset,
  };
}
